/**
 * Methodological Application
 * файл кодируется в UTF-8
 *
 * @package Methodological
 * @subpackage apkpro
 * @copyright 2023 Eugene Generalov
 */

import {BitrixVue} from "ui.vue3";
import {createStore} from 'ui.vue3.vuex';
import {Dom, Loc} from 'main.core';

import {filtersStore} from "./stores/filters";
import {itemsStore} from "./stores/items";

import {Main} from './component/main';

export class Methodological {
	#store;
	#application;

	constructor(rootNode): void
	{
		this.#store = createStore({
			modules: {
				filtersStore,
				itemsStore,
			}
		});
		this.rootNode = document.querySelector(rootNode);
	}

    start(): void
	{
		const context = this;
		this.#application = BX.Vue3.BitrixVue.createApp({
			name: 'Methodological',
			components: {
				Main
			},
			template: '<Main/>'
		});

		this.#application.use(this.#store)
		this.#application.mount(this.rootNode)
    }
}